import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
export class SetArbetsorderVirketMarktCommand extends BasicCommand<SetArbetsorderVirketMarktCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    virketMarkt: string;
    constructor(init: (instance: SetArbetsorderVirketMarktCommand) => void) {
        super("SetArbetsorderVirketMarktCommand", "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
